require('./plugins/morrisjs/morris.min');

export class Application {
	defaultOptions() {
		return {
			private: {
				//time: null,
				timeInterval: null,
				//timeSyncInterval: null,
			},
		};
	}

	constructor() {
		this.$options = this.defaultOptions();
		this._notificationsEnabled = false;
		
		this.init();
	}

	//=====================================================================
	// 
	//=====================================================================

	actualizeTime() {
		let now = new Date(),
			str = formatDateTime(now, true);
		$('#navbar-current-time').html(str);
	}
	
	saveNavbarDetailSetup(set) {
		Cookies.set('navbar-detail-keep-open', set ? "true" : "false");
	}
	
	loadNavbarDetailSetup() {
		var navbarDetailSetup = Cookies.get('navbar-detail-keep-open');
		if (navbarDetailSetup === "true") {
			$('#navbar-shift-detail').addClass('open');
			$('input#navbar-detail-keep-open').attr('checked', 'checked');
		}
	}
	
	//=====================================================================

	demandsAutomaticReload(timeout) {
		const app = this;
		window.setTimeout(function() {
			app.pollDemandsNotif();
		}, timeout);
	}

	pollDemandsNotif() {
		const app = this;
		const demands = $('#js-opts-common').data('demands');
		const demandsMessages = $('#navbar-messages');

		let lastDemand = demands.reduce((max, demand) => {
			return (demand.id > max.id) ? demand : max
		}, demands[0]);

		function newMessage() {
			for (const demand of demands) {
				if (!demand.read) {
					demandsMessages.addClass('new-message');
					break;
				}
			}
		}

		newMessage();
		
		$.ajax({
			type: "post",
			url: route('demands.pollNewDemands'),
			data: {
				'lastDemand': lastDemand ? lastDemand.id : null
			},
			timeout: 20000,
			success: function (result) {

				if (result && result.length > 0)
				{
					$('#js-opts-common').data('demands', result);
					newMessage();

					if (app._notificationsEnabled)
					{
						let options = {
							body: $Lang.common.header.newMessageReceived,
							icon: $('base').attr('href') + "/assets/main_logo.png",
						};
						
						new Notification("Violet", options);
					}
				}

				app.demandsAutomaticReload(100);
			},
			error: function (result) {
				app.demandsAutomaticReload(1000)
				console.error(result);
			}
		});
	}

	demandsList() {
		const demands = $('#js-opts-common').data('demands');
		const demandsList = $('#navbar-demands-list');

		demandsList.children('li').not(':last').remove();

		demands.forEach((demand) => {
			let demandHtml = 	`<li class="navbar-demand${ !demand.read ? ' new-demand' : ''}">` +
									`<a href="${ demand.url }">` +
										`<div>` +
											`<strong>${ demand.name }</strong>` +
											`<strong class="pull-right text-muted">` +
												`<em>${ demand.createdAt }</em>` +
											`</strong>` +
										`</div>` +
										`<div>${ demand.shortText }</div>` +
									`</a>` +

									(demand.related_object_url 
									? `<a href="${demand.related_object_url}">${demand.related_object_uid}</a>` 
									: ``) +

								`</li>` +
								`<li class="divider"></li>`;
			
			demandsList.prepend(demandHtml);
		});
	}
	
	//=====================================================================

	/**
	 * 
	 */
	checkNotificationPermissions() {
		let app = this;
		if ('Notification' in window) {
			if (window.Notification.permission !== "granted") {
				Notification.requestPermission().then((result) => {
					app._notificationsEnabled = (result === "granted");
				});
			}
			else if (window.Notification.permission === "granted") {
				app._notificationsEnabled = true;
			}
		}
	}

	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	init() {
		var app = this,
			$document = $(document),
			$successAlert = $(".alert-success");
		
		app.$options.private.time = new Date();
		app.$options.private.timeInterval = window.setInterval(function () {
			app.actualizeTime();
		}, 1000);
		
		app.loadNavbarDetailSetup();
		app.demandsAutomaticReload(100);
		app.checkNotificationPermissions();

		$document.on('click', '#navbar-messages-button', function() {
			app.demandsList();
		});
	
		$document.on('click', '.navbar-info', function() {
			$('#navbar-shift-detail').toggleClass('open');
		});
		$document.on('change', '#navbar-detail-keep-open', function() {
			app.saveNavbarDetailSetup(this.checked);
		});

		setTimeout((function() {
			$successAlert.remove()
		}), 10000)
	}
}

